import { make } from './Touchable.gen'

type TouchableProps = React.ComponentProps<typeof make>

const Touchable = make as React.FunctionComponent<TouchableProps>

Touchable.displayName = 'Touchable'

export { Touchable, type TouchableProps }
